import { Box, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled(Box) `
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
`;
export const Divider = styled.div `
  width: 100%;
  border-bottom: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
